import { FileUp, type LucideIcon } from 'lucide-react';

export const FileUploadIcon: LucideIcon = FileUp;
